import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=4f0bc98f&scoped=true"
import script from "./detailList.vue?vue&type=script&lang=js"
export * from "./detailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0bc98f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f0bc98f')) {
      api.createRecord('4f0bc98f', component.options)
    } else {
      api.reload('4f0bc98f', component.options)
    }
    module.hot.accept("./detailList.vue?vue&type=template&id=4f0bc98f&scoped=true", function () {
      api.rerender('4f0bc98f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/service/statisticAnalyse/detailList.vue"
export default component.exports